// Color scales for AVIV price tiles - matches legacy www-flask MAP_PALETTES

const LEGACY_OPACITY = 0.6;

export const colorscales = {
    12: {
        levels: [
            `rgba(0,136,85,${LEGACY_OPACITY})`,
            `rgba(19,190,0,${LEGACY_OPACITY})`,
            `rgba(117,225,0,${LEGACY_OPACITY})`,
            `rgba(174,229,0,${LEGACY_OPACITY})`,
            `rgba(223,255,0,${LEGACY_OPACITY})`,
            `rgba(255,248,49,${LEGACY_OPACITY})`,
            `rgba(255,232,47,${LEGACY_OPACITY})`,
            `rgba(255,213,0,${LEGACY_OPACITY})`,
            `rgba(255,165,31,${LEGACY_OPACITY})`,
            `rgba(255,123,22,${LEGACY_OPACITY})`,
            `rgba(255,10,2,${LEGACY_OPACITY})`,
            `rgba(200,0,0,${LEGACY_OPACITY})`,
        ],
        opacity: LEGACY_OPACITY,
    },
    11: {
        levels: [
            `rgba(0,136,85,${LEGACY_OPACITY})`,
            `rgba(19,190,0,${LEGACY_OPACITY})`,
            `rgba(117,225,0,${LEGACY_OPACITY})`,
            `rgba(174,229,0,${LEGACY_OPACITY})`,
            `rgba(223,255,0,${LEGACY_OPACITY})`,
            `rgba(255,248,49,${LEGACY_OPACITY})`,
            `rgba(255,213,0,${LEGACY_OPACITY})`,
            `rgba(255,165,31,${LEGACY_OPACITY})`,
            `rgba(255,123,22,${LEGACY_OPACITY})`,
            `rgba(255,10,2,${LEGACY_OPACITY})`,
            `rgba(200,0,0,${LEGACY_OPACITY})`,
        ],
        opacity: LEGACY_OPACITY,
    },
    10: {
        levels: [
            `rgba(0,136,85,${LEGACY_OPACITY})`,
            `rgba(19,190,0,${LEGACY_OPACITY})`,
            `rgba(117,225,0,${LEGACY_OPACITY})`,
            `rgba(174,229,0,${LEGACY_OPACITY})`,
            `rgba(223,255,0,${LEGACY_OPACITY})`,
            `rgba(255,248,49,${LEGACY_OPACITY})`,
            `rgba(255,165,31,${LEGACY_OPACITY})`,
            `rgba(255,123,22,${LEGACY_OPACITY})`,
            `rgba(255,10,2,${LEGACY_OPACITY})`,
            `rgba(200,0,0,${LEGACY_OPACITY})`,
        ],
        opacity: LEGACY_OPACITY,
    },
    9: {
        levels: [
            `rgba(0,136,85,${LEGACY_OPACITY})`,
            `rgba(19,190,0,${LEGACY_OPACITY})`,
            `rgba(117,225,0,${LEGACY_OPACITY})`,
            `rgba(174,229,0,${LEGACY_OPACITY})`,
            `rgba(255,248,49,${LEGACY_OPACITY})`,
            `rgba(255,165,31,${LEGACY_OPACITY})`,
            `rgba(255,123,22,${LEGACY_OPACITY})`,
            `rgba(255,10,2,${LEGACY_OPACITY})`,
            `rgba(200,0,0,${LEGACY_OPACITY})`,
        ],
        opacity: LEGACY_OPACITY,
    },
    8: {
        levels: [
            `rgba(0,136,85,${LEGACY_OPACITY})`,
            `rgba(19,190,0,${LEGACY_OPACITY})`,
            `rgba(117,225,0,${LEGACY_OPACITY})`,
            `rgba(255,248,49,${LEGACY_OPACITY})`,
            `rgba(255,165,31,${LEGACY_OPACITY})`,
            `rgba(255,123,22,${LEGACY_OPACITY})`,
            `rgba(255,10,2,${LEGACY_OPACITY})`,
            `rgba(200,0,0,${LEGACY_OPACITY})`,
        ],
        opacity: LEGACY_OPACITY,
    },
    7: {
        levels: [
            `rgba(19,190,0,${LEGACY_OPACITY})`,
            `rgba(117,225,0,${LEGACY_OPACITY})`,
            `rgba(174,229,0,${LEGACY_OPACITY})`,
            `rgba(255,248,49,${LEGACY_OPACITY})`,
            `rgba(255,165,31,${LEGACY_OPACITY})`,
            `rgba(255,123,22,${LEGACY_OPACITY})`,
            `rgba(255,10,2,${LEGACY_OPACITY})`,
        ],
        opacity: LEGACY_OPACITY,
    },
    6: {
        levels: [
            `rgba(19,190,0,${LEGACY_OPACITY})`,
            `rgba(117,225,0,${LEGACY_OPACITY})`,
            `rgba(174,229,0,${LEGACY_OPACITY})`,
            `rgba(255,248,49,${LEGACY_OPACITY})`,
            `rgba(255,123,22,${LEGACY_OPACITY})`,
            `rgba(255,10,2,${LEGACY_OPACITY})`,
        ],
        opacity: LEGACY_OPACITY,
    },
    5: {
        levels: [
            `rgba(19,190,0,${LEGACY_OPACITY})`,
            `rgba(174,229,0,${LEGACY_OPACITY})`,
            `rgba(255,248,49,${LEGACY_OPACITY})`,
            `rgba(255,165,31,${LEGACY_OPACITY})`,
            `rgba(255,10,2,${LEGACY_OPACITY})`,
        ],
        opacity: LEGACY_OPACITY,
    },
    4: {
        levels: [
            `rgba(19,190,0,${LEGACY_OPACITY})`,
            `rgba(255,248,49,${LEGACY_OPACITY})`,
            `rgba(255,165,31,${LEGACY_OPACITY})`,
            `rgba(255,10,2,${LEGACY_OPACITY})`,
        ],
        opacity: LEGACY_OPACITY,
    },
    3: {
        levels: [
            `rgba(174,229,0,${LEGACY_OPACITY})`,
            `rgba(255,248,49,${LEGACY_OPACITY})`,
            `rgba(255,165,31,${LEGACY_OPACITY})`,
        ],
        opacity: LEGACY_OPACITY,
    },
    2: {
        levels: [`rgba(0,136,85,${LEGACY_OPACITY})`, `rgba(200,0,0,${LEGACY_OPACITY})`],
        opacity: LEGACY_OPACITY,
    },
};

export const NO_DATA_COLOR_ROADMAP = 'rgba(180, 180, 180, 0.4)';
export const NO_DATA_COLOR = NO_DATA_COLOR_ROADMAP;

// Create Mapbox stops-based fill-color property
export function createColorStops(colorLevels, noDataColor = NO_DATA_COLOR_ROADMAP) {
    return {
        property: 'value',
        stops: colorLevels.map((color, index) => [index + 1, color]),
        default: noDataColor,
    };
}

export default {
    colorscales,
    NO_DATA_COLOR,
    NO_DATA_COLOR_ROADMAP,
    createColorStops,
};
